import {
	TOGGLE_KPIS_UPLOAD_DIALOG,
	GET_KPI_FILES_TREE,
	GET_TREE_LAST_UPDATE,
	GET_KPI_PROCESS_TABLE,
	SET_SELECT_FILES
} from '../actions/DriveTestUploadActions';

const initialState = {
	kpiFilesTree: {
		directory: '',
		ftpFileInfo: []
	},
	kpiProcessTable: [],
	kpisUploadDialogVisibility: false,
	treeLastUpdate: '',
	selectedFiles: []
};

const driveTestUploadReducer = (state = initialState, action) => {
	switch (action.type) {
					case TOGGLE_KPIS_UPLOAD_DIALOG: {
						return {
							...state,
							kpisUploadDialogVisibility: action.visible
						};
					}
					case GET_KPI_FILES_TREE: {
						return {
							...state,
							kpiFilesTree: action.kpiFilesTree
						};
					}
					case GET_TREE_LAST_UPDATE: {
						return {
							...state,
							treeLastUpdate: action.treeLastUpdate
						};
					}
					case GET_KPI_PROCESS_TABLE: {
						return {
							...state,
							kpiProcessTable: action.kpiProcessTable
						};
					}
					case SET_SELECT_FILES: {
						return {
							...state,
							selectedFiles: action.selectedFiles
						};
					}
					default: {
						return state;
					}
	}
};

export default driveTestUploadReducer;
